import { defaultAdultAge } from "@/helpers/defaultAdultAge.ts";
import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { mergeRatePlans } from "@/helpers/mergeRatePlans.ts";
import { PersonType, ReservationOfferAccommodation } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { AdultType } from "@/stores/EngineStore/interfaces/AdultType.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { ChildType } from "@/stores/EngineStore/interfaces/ChildType.ts";

const convertReservationToCartItem = (
  reservation: ReservationOfferAccommodation,
  state: EngineStoreData,
): CartAccommodationItem => {
  const adults: AdultType[] = [];
  const children: ChildType[] = [];
  const rateGroup = state.availableRateGroups.find((rg) =>
    rg.ratePlans.find((rp) => rp.id === reservation.ratePlan.id),
  )!;

  reservation.guests.forEach((guest) => {
    if (guest.personType === PersonType.Adult) {
      adults.push({ id: guest.id, type: PersonType.Adult, age: defaultAdultAge });
    } else {
      children.push({ id: guest.id, type: PersonType.Child, age: guest.age || 1 });
    }
  });

  const ratePlan: RatePlanMerged = {
    ...reservation.ratePlan,
    childRatePlans: mergeRatePlans(rateGroup),
    rateGroup: rateGroup,
  };

  return {
    id: reservation.id,
    mandatoryExtras: [],
    adults,
    children,
    optionalExtras: [],
    dateRange: [new Date(reservation.checkIn), new Date(reservation.checkOut)],
    ratePlan,
    rateGroup,
  };
};

export const addFullCartAccommodationItemsHelper = (
  state: EngineStoreData,
  accommodations: ReservationOfferAccommodation[],
) => {
  const cartAccommodationItems: CartAccommodationItem[] = accommodations.map((acc) =>
    convertReservationToCartItem(acc, state),
  );

  // must set defaultDateRange from first accommodation (since all accommodations must have the same date range)
  const newDefaultDateRange = cartAccommodationItems[0].dateRange;

  return { ...state, defaultDateRange: newDefaultDateRange, cartAccommodationItems };
};
